import { apiRequest } from './client'
import {
  CreateUserRequest,
  CreateUserResponse,
  ListUsersResponse,
  UserInfo,
  MessageResponse,
  ActionResult,
} from '@/lib/types'

export async function createUser(
  request: CreateUserRequest
): Promise<ActionResult<CreateUserResponse>> {
  return apiRequest<CreateUserResponse>('/admin/users/create', {
    method: 'POST',
    body: JSON.stringify(request),
  })
}

export async function listUsers(): Promise<ActionResult<ListUsersResponse>> {
  return apiRequest<ListUsersResponse>('/admin/users')
}

export async function getUser(login: string): Promise<ActionResult<UserInfo>> {
  return apiRequest<UserInfo>(`/admin/users/get?login=${encodeURIComponent(login)}`)
}

export async function deleteUser(login: string): Promise<ActionResult<MessageResponse>> {
  return apiRequest<MessageResponse>('/admin/users/delete', {
    method: 'POST',
    body: JSON.stringify({ login }),
  })
}

export async function resetPassword(
  login: string,
  newPassword: string
): Promise<ActionResult<MessageResponse>> {
  return apiRequest<MessageResponse>('/admin/users/reset-password', {
    method: 'POST',
    body: JSON.stringify({ login, new_password: newPassword }),
  })
}
